/**
 * Export the sub-modules
 * @type {Object}
 */
var CLReact = {
  // Components
  get CLApi() {
    return require('./modules/cl-api');
  },

  get Appinst() {
    return require('./modules/cl-app');
  },

  get Auth() {
    return require('./modules/cl-auth');
  },

  get CLStorage() {
    return require('./modules/cl-storage');
  },

  get Utils() {
    return require('./modules/cl-utils');
  },

  get CLAnalytics() {
    return require('./modules/cl-analytics');
  },

  get CLIntegrations() {
    return require('./modules/cl-integrations');
  } // get LoginButton() { return require('./components/LoginButton'); },
  // get LogoutButton() { return require('./components/LogoutButton'); },
  // get SignupButton() { return require('./components/SignupButton'); },
  // get Actions() { return require('./state/cl-actions'); },
  // get Reducers() { return require('./state/cl-reducers'); },


}; //console.log("CLReact",CLReact);

module.exports = CLReact;